import $ from 'jquery';
import { getTotalIMSTargetedSelected } from '../showroom/showroom-utilities.js';
import { hasAttr } from '../utilities.js';
import { Formatter } from '@dealersites/dealersite-js-core';

$('.js-masonry-item').each(function () {
  const $item = $(this);
  const srcUrl = $item.data('url');

  const galleryImage = new Image();

  galleryImage.onload = () => {
    $item.find('.js-image-item').removeClass('opacity-0');
    $item.removeClass('placeholder-image');
  };

  galleryImage.onerror = () => {};
  galleryImage.src = srcUrl;

});


const galleryID = 'vdp-gallery-slider';
const $vdpGallerySlider = $(`.${galleryID}`);
const $vdpGalleryPreviewSlider = $(`.${galleryID}-for`);

$vdpGallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $(`.controls-dots-${galleryID}`).data('theme');
    dots.addClass('slick-dot ' + theme);
  }
});

$vdpGallerySlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  speed: 200,
  touchThreshold: 100,
  asNavFor: `.${galleryID}-for`,
  appendDots: $(`.controls-dots-${galleryID}`),
  nextArrow: $(`.controls-next-${galleryID}`),
  prevArrow: $(`.controls-prev-${galleryID}`),
});

$vdpGalleryPreviewSlider.slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: `.${galleryID}`,
  focusOnSelect: true,
  centerMode: true,
  dots: false,
  speed: 200,
  touchThreshold: 100,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
        dots: false,
        centerMode: true
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 3,
        dots: false,
        centerMode: true
      },
    },
  ],
});

const similarGalleryID = 'vdp-similar-slider';
const $vdpSimilarSlider = $(`.${similarGalleryID}`);

if ($vdpSimilarSlider.length != 0) {
const $similarCurrentSlide = $(`.controls-current-${similarGalleryID}`);

$vdpSimilarSlider.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  dots: false,
  arrows: true,
  infinite: true,
  nextArrow: $(`.controls-next-${similarGalleryID}`),
  prevArrow: $(`.controls-prev-${similarGalleryID}`),
  responsive: [
    {
      breakpoint: 1590,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1160,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8%',
      },
    },
  ],
});

  // sets position
  $vdpSimilarSlider.on('init beforeChange afterChange', function (event, slick) {
     $vdpSimilarSlider.slick('setPosition');
  });

  // Adjusts height of all slides to the tallest one
  $vdpSimilarSlider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });

  $vdpSimilarSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
    if (slick.slideCount > 1) {
      const current = (currentSlide ? currentSlide : 0) + 1;
      if ($similarCurrentSlide.length !=0 ) {
        $similarCurrentSlide.text(current + '/' + slick.slideCount);
      }
    } else {
      $similarCurrentSlide.remove();
    }
  });
}



// VDP Price Card Targeted Incentive Handling

$('.vdp-targeted-incentives .js-targeted-incentive').on('change', function () {
  const $breakdown = $('.js-vdp-breakdown-data');

  // G - Total Targeted Cash of checked/selected
  const totalCashTargeted = getTotalIMSTargetedSelected('cash');

  // A-0 - Final Price (pre tax)
  const pricePreTax = $breakdown.data('price-pre-tax');

  // A-0 - new Final Price (pre tax) with Targeted Cash deducted
  let price = pricePreTax - totalCashTargeted;

  // C - check for tax adjustment
  const hasTax = hasAttr($breakdown, 'data-has-tax');

  if (hasTax) {
    const taxRate = $breakdown.data('tax-rate');
    // C - new Estimated Tax
    const estimatedTax = price * (taxRate / 100);
    // C - update Estimated Tax
    const $estimatedTax = $('.js-estimated-tax');
    $estimatedTax.text('+' + Formatter.price(estimatedTax, 0));
    // A - new Final Price with Tax
    price = price + estimatedTax;
  }

  // A - update Final Prices
  const $finalPrices = $('.js-final-price');

  $finalPrices.each(function () {
    $(this).text(Formatter.price(price, 0));
  });
});
